import moment from 'moment'
import conf from 'conf'
import Vue from 'vue'
import CookieUtils from 'utils/CookieUtils'
import gtmFSF from 'services/AirBaltic/GTM/FSF'
import * as Sentry from '@sentry/vue'
import FsfMixin from 'components/FlightSearchForm/FsfMixin'
import { mapGetters } from 'vuex'

const cookieExpDays = 14

const RecentSearchMixin = {
  computed: {
    ...mapGetters('main', ['shouldRedirectToNewFSF'])
  },
  mixins: [FsfMixin],
  methods: {
    loadSearch(search, sref = '') {
      this.addSearchToCookie(search)
      gtmFSF.fsfRecentSearch(search)
      const departureDate = this.getFlightDate(search.departure)
      const returnDate = this.getFlightDate(search.return)
      const tripType = search.tripType === 1 ? 'oneway' : 'return'
      if (!departureDate || search.promoCodes?.length) {
        this.getOrigDestData()
        this.$store.commit('eHorizonSearchForm/setTripType', tripType)
        this.$store.commit('eHorizonSearchForm/setSref', sref)
        this.$store.commit(
          'eHorizonSearchForm/paxSelector/setAdults',
          parseInt(search.adults)
        )
        this.$store.commit(
          'eHorizonSearchForm/paxSelector/setChildren',
          parseInt(search.children)
        )
        this.$store.commit(
          'eHorizonSearchForm/paxSelector/setInfants',
          parseInt(search.infants)
        )
        let promoCodes = []
        if (search.promoCodes) {
          search.promoCodes.forEach((code, index) => {
            if (code) {
              promoCodes.push({ index: index, code: code, error: '' })
            }
          })
        }
        this.$store.commit('eHorizonSearchForm/promoCodes/setPromoCodes', promoCodes)

        this.$store.dispatch(
          'eHorizonSearchForm/calendar/updateDepartureDate',
          departureDate
        )
        this.$store.dispatch('eHorizonSearchForm/calendar/updateReturnDate', returnDate)

        if (origDestData) {
          const origin = origDestData[search.fromCode + search.fromType]
          const destin = origDestData[search.toCode + search.toType]
          this.$store.dispatch('eHorizonSearchForm/selectOrigin', origin)
          this.$store.dispatch('eHorizonSearchForm/destin/onValueSelect', destin)
        }

        if (this.shouldRedirectToNewFSF) {
          this.$_fsfMixin_redirectToNewFSF()
          return
        }

        this.$_fsfMixin_openFsfModal(false, true, true)
        return
      }

      let link =
        conf.newIbeUrl +
        '/' +
        Vue.i18n.locale() +
        '/fb/availability?' +
        (departureDate !== '' ? '&departure=' + departureDate : '') +
        (returnDate !== '' ? '&return=' + returnDate : '') +
        '&originCode=' +
        search.fromCode +
        '&destinCode=' +
        search.toCode +
        '&tripType=' +
        tripType +
        '&originType=' +
        search.fromType +
        '&destinType=' +
        search.toType +
        (sref ? '&sref=' + sref : '') +
        '&p=bti' +
        '&pos=LV' +
        '&l=' +
        Vue.i18n.locale() +
        '&numAdt=' +
        search.adults

      if (search.children > 0) {
        link += '&numChd=' + search.children
      }

      if (search.infants > 0) {
        link += '&numInf=' + search.infants
      }

      window.location.href = link
    },

    getAirportType(code) {
      if (code === 'LON' || code === 'MIL' || code === 'TCI') {
        return 'C'
      }

      return 'A'
    },

    getFlightDate(date) {
      const diff = moment().diff(moment(date), 'days')
      return diff <= 0 ? date : ''
    },

    addSearchToCookie(searchedItem) {
      let cookie = [searchedItem]
      const recentSearchCookie = CookieUtils.getCookie('recentSearch')

      if (recentSearchCookie) {
        try {
          cookie = JSON.parse(recentSearchCookie)
          if (typeof cookie[0] !== 'undefined') {
            const index = cookie.findIndex(
              (item) =>
                item.fromCode === searchedItem.fromCode &&
                item.toCode === searchedItem.toCode
            )
            if (index !== -1) {
              cookie.splice(index, 1)
            }
          }

          cookie.unshift(searchedItem)
          cookie = cookie.slice(0, 2)
        } catch (e) {
          Sentry.captureException(e)
        }
      }
      cookie = JSON.stringify(cookie)
      CookieUtils.setCookie('recentSearch', cookie, cookieExpDays)
    },

    removeRecentSearchByIndex(index) {
      const recentSearchCookie = this.getSearchCookie()
      try {
        let cookie = JSON.parse(recentSearchCookie)
        cookie.splice(index, 1)
        cookie = JSON.stringify(cookie)
        CookieUtils.setCookie('recentSearch', cookie, cookieExpDays)
        this.$store.commit('eHorizonSearchForm/recentSearch/removeSearch', index)
      } catch (e) {
        Sentry.captureException(e)
      }
    },

    getSearchCookie() {
      return CookieUtils.getCookie('recentSearch')
    }
  }
}

export default RecentSearchMixin
